import ListColor from './content/ListColor'

function Color({ enableSelect, handleSelect }) {

    return (
        <ListColor enableSelect={enableSelect} handleSelect={handleSelect} />
    )
}

export default Color
